import React from 'react';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '../Button/Button';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface SaveCancelButtonsProps {
  onSave?: () => void;
  onCancel?: () => void;
  containerStyle?: object;
  cancelButtonStyle?: object;
  saveButtonStyle?: object;
  loading?: boolean;
  loadingText?: ReactNode | string;
  saveValue?: ReactNode | string;
  cancelValue?: ReactNode | string;
  customCancelDisabled?: boolean;
  customSaveDisabled?: boolean;
  showSaveButton?: boolean;
  showCancelButton?: boolean;
}

const SaveCancelButtons: React.FC<SaveCancelButtonsProps> = ({
  onSave,
  onCancel,
  containerStyle = {},
  cancelButtonStyle = {},
  saveButtonStyle = {},
  loading = false,
  loadingText,
  saveValue,
  cancelValue,
  customCancelDisabled = false,
  customSaveDisabled = false,
  showSaveButton = true,
  showCancelButton = true,
}) => {
  const { t } = useTranslation();
  const resolvedLoadingText = loadingText ?? t('common.saving', 'Saving');
  const resolvedSaveValue = saveValue ?? t('common.saveUpper', 'SAVE');
  const resolvedCancelValue = cancelValue ?? t('common.cancelUpper', 'CANCEL');
  return (
    <FormControl component="fieldset" sx={{ width: '100%', marginTop: '20px', ...containerStyle }}>
      <Stack
        direction={{ xs: 'row', sm: 'row' }}
        alignItems="center"
        justifyContent="flex-end"
        sx={{ width: '100%' }}
        gap={{ xs: 2, md: 3 }}
      >
        {showCancelButton && (
          <Button
            variant="outlined"
            onClick={onCancel}
            sx={{  
              ...cancelButtonStyle,
            }}
            disabled={loading || customCancelDisabled}
          >
            {resolvedCancelValue}
          </Button>
        )}

        {showSaveButton && (
          <Button
            variant="contained"
            onClick={onSave}
            sx={{
              ...saveButtonStyle,
            }}
            disabled={loading || customSaveDisabled}
          >
            {loading ? (
              <>
                {resolvedLoadingText}
                <CircularProgress
                  size={25}
                  sx={{ marginLeft: '10px', marginRight: 1, color: 'white' }}
                />
              </>
            ) : (
              resolvedSaveValue
            )}
          </Button>
        )}
      </Stack>
    </FormControl>
  );
};

export default SaveCancelButtons;
